import {Component} from 'react'
import {connect} from 'react-redux'

import * as types from './constants'

export class CurrentRegHolderWrapper extends Component {

  constructor(props) {
    super(props)
    props.setCurrentRegHolder(props.current_reg_holder)
  }

  componentDidUpdate(prevProps) {
    const { current_reg_holder: new_reg_holder } = this.props
    const { current_reg_holder, setCurrentRegHolder } = prevProps

    if ((new_reg_holder || {}).id !== (current_reg_holder || {}).id) {
      setCurrentRegHolder(new_reg_holder)
    }
  }

  render() {
    // If we are embedded we don't want to render the view
    // (that is called seperately if we are standalone)
    return this.props.children
  }
}

const defaultState = {
  current_reg_holder: {}
}

export const Reducer = (state = defaultState, action) => {
  switch (action.type) {
  case types.SET_CURRENT_REG_HOLDER:
    return Object.assign(
      {},
      state,
      {...action.current_reg_holder}
    )
  default:
    return state
  }
}

const setCurrentRegHolder = (current_reg_holder) => ({
  type: types.SET_CURRENT_REG_HOLDER,
  current_reg_holder
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentRegHolder: (current_reg_holder) => {
    dispatch(setCurrentRegHolder(current_reg_holder))
  }
})

export const mapStateToProps = (state) => ({
  current_reg_holder: state.current_reg_holder
})

export default connect(null, mapDispatchToProps)(CurrentRegHolderWrapper)



// WEBPACK FOOTER //
// ./src/layout/authorised-layout/current-reg-holder/container.js